import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;

export const notificationService = { getAll, store, show, update };

export function getAll(filter = {}) {
    const params = {
        page: filter.pageNumber,
        size: filter.pageSize,
        type: filter.type === '' ? undefined : filter.type,
        sortBy: filter.sortBy,
        orderBy: filter.orderBy,
    };

    const searchWords = (filter.searchArray || []).filter((word) => word != null && word !== '');
    if (searchWords.length) params.search_words = searchWords;

    return apiHelper(API_URL).get('/notifications', { params });
}

function requestData(data) {
    return {
        code: data.code || null,
        name: data.name,
        title: data.title,
        long_description: data.longDescription || null,
        description: data.description || null,
        email_subject: data.emailSubject || null,
        email_html_content: data.emailHtmlContent || null,
        type: data.type,
        redirect_page: data.redirectPage || null,
        redirect_page_prmtr: data.redirectPageParameters || [],
        icon_uuid: data.iconUUID || null,
        channel_uuids: data.channelUUIDs || [],
        whatsapp_template_name: data.whatsappTemplateName || null,
        whatsapp_template_language: data.whatsappTemplateLanguage || null,
        whatsapp_template_prmtr_keys: data.whatsappTemplateParameterKeys || [],
        is_active: data.isActive,
    };
}

export function store(data) {
    return apiHelper(API_URL).post('/notifications', requestData(data));
}

export function show(uuid) {
    return apiHelper(API_URL).get(`/notifications/${uuid}`);
}

export function update(data) {
    return apiHelper(API_URL).put(`/notifications/${data.uuid}`, requestData(data));
}
